export interface Pair {
  name: string;
  ask_price?: number;
  percentage?: number;
  quote_logo: string;
  quote_asset_id: string;
  volume: number;
  base_asset: string;
  base_logo?: string;
}

export enum Percentages {
  "5%" = "5%",
  "25%" = "25%",
  "50%" = "50%",
  "75%" = "75%",
  "100%" = "100%",
}
